export enum MapBusinessStatus {
	OPEN = "OPEN",
	CLOSED_TEMPORARILY = "CLOSED_TEMPORARILY",
	CLOSED = "CLOSED",
}
